<mat-card class="example-card">

    <mat-card-header class="card-header">
      <mat-card-title class="card-titulo">Gestión de Jobs del Sistema</mat-card-title>
    </mat-card-header>

    <mat-card-content>
  
      <mat-card-content>

        <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px;">

          <div fxFlex=100 fxFlex.xs=100 class="flex-item" *ngIf="canViewMovimientosSegundoVencimiento">
            <app-jobsMovimientoSegundoVencimiento></app-jobsMovimientoSegundoVencimiento>
          </div>

        </div>

      </mat-card-content>
  
    </mat-card-content>

  </mat-card>
